
export const mutations = {
  MutationAffiliateCampaign(state, info) {
    state.affiliateCampaignModel = info;
  },
  MutationCheckAffiliateCampaign(state, info) {
    state.httpCodeCheckAffiliatesStatus = info.code;
    state.messageCheckAffiliatesCampaign = info.message;
    state.propCheckAffiliatesCampaign = info.prop;
  },
  MutationCampaign(state, info) {
    state.campaignModel = info;
  },
  MutationRestateAffiliates(state) {
    state.affiliateCampaignModel = null;
    state.messageCheckAffiliatesCampaign = null;
    state.httpCodeCheckAffiliatesStatus = null;
    state.campaignModel = null;
  }
};
